import React, {Component} from 'react';
import './login.sass';
import FirebaseContext from "../Firebase/context";
import i18next from "../../utils/i18n";


class Login extends Component {


    render() {
        const {email, password, submitted, loading, error, handleSubmit, handleChange} = this.props;
        return (
            <div className="card">
                <div className="login">
                    <div className="logo_title">
                        <h2>Login</h2>
                        <div className="logo_small">
                        </div>
                    </div>
                    <form name="form" onSubmit={this.handleSubmit}>
                        <div className='form_input'>
                            <label>Email</label>
                            <input type="text" name="email" value={email} onChange={handleChange}/>
                            {submitted &&
                            <div className="help_block">Il campo email è obbligatorio</div>
                            }
                        </div>
                        <div className="form_input">
                            <label>Password</label>
                            <input type="password" name="password" value={password} onChange={handleChange}/>
                            {submitted &&
                            <div className="help_block">Il campo password è obbligatorio</div>
                            }
                        </div>

                        <button className="button_login" disabled={loading} onClick={handleSubmit}>Login</button>

                        {error &&
                        <div className="help_block">{error}</div>
                        }

                        <label className='informativa_privacy_min'>Prendi visione dell' <a href='/privacy'> informativa sulla privacy</a></label>
                    </form>
                </div>

                <div className="container_logo">
                    <div className="logo"></div>
                    <label className='informativa_privacy'>Prendi visione dell' <a href='/privacy'> informativa sulla privacy</a></label>
                </div>
            </div>


        )
    }
}

Login.contextType = FirebaseContext;

export default Login;